import {
  TaskRequestModel,
  Tasks,
  TasksService,
} from '@compumark/analyst-selection-tool-client';
import { ResultSortService } from '../../../results/services/result-sort.service';
import { first } from 'rxjs';
import { TaskFilterModelService } from './task-filter-model.service';
import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-community';
import { Injectable } from '@angular/core';

@Injectable()
export class TasksOverviewDatasource {
  constructor(
    private taskService: TasksService,
    private taskFilterModelService: TaskFilterModelService,
    private resultSortService: ResultSortService,
  ) {}

  createFor(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams): void => {
        const filterModel = this.taskFilterModelService.createTaskFilter(
          params.request.filterModel,
        );

        const sortModel = this.resultSortService.getSortModel(params);

        const taskRequest: TaskRequestModel = {
          startWith: params.request.startRow!,
          endBefore: params.request.endRow!,
          taskFilter: filterModel,
          sort: sortModel,
        };

        this.taskService
          .getTasks(
            taskRequest,
            params.request.startRow!,
            params.request.endRow!,
          )
          .pipe(first())
          .subscribe((taskList: Tasks) => {
            params.success({
              rowData: taskList.taskList,
              rowCount: taskList.taskCount,
            });
          });
      },
    };
  }
}
